import React from 'react';
import FactoryIcon from '@mui/icons-material/Factory';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [{ key: 'name', label: 'Name', required: true }];

const ManufacturerManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Manufacturer Management"
    icon={<FactoryIcon />}
    apiPath="/api/manufacturers"
    fields={fields}
    entityLabel="Manufacturer"
  />
);

export default ManufacturerManagement;
